import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import AppView from '~common/components/app-view/index';

import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list-fc';

import portalUserContext from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';
import * as request from 'superagent';


// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  containerPreFc: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden'
  },
  container: {
    width: '100%'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready';
  error?: any;
  form: any;
};

class GroupAdminQueryList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
      form: {}
    };
  }

  componentDidMount() {
   
  }

  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>()
  
    return actions
  }

  handleRowClick = (item) => {
    var criteria = URLManager.getQueryString(window.location.href)
    window.location.href = `/groups/admin/${item.id}?q=${URLManager.getQueryStringValue(criteria)}`
  }

  onCriteriaFormSelection = (form: any) => {
    form.predefined.forEach((pdf: any)=>{
      if (pdf.key == "restrictToUserType") {
        pdf.options = []
         if (portalUserContext.hasOneOfFeatures(["group_admin_vendor"])) {
           pdf.options.push({label: "Vendor", value: "Vendor"})
         }
         if (portalUserContext.hasOneOfFeatures(["group_admin_internal"])) {
          pdf.options.push({label: "Internal", value: "Internal"})
        }
        if (pdf.options.length == 0) {
          pdf.mode = "Hidden"
        }
      }
    })
  }
  
  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status, form} = this.state;

    console.log("LOVES group admin list", form)
   

    var criteriaSelector = {
      "app": "admin",
      "form": "groupSearchCriteria"
    }

    criteriaSelector["userType"] = portalUserContext.userType
    if (criteriaSelector["userType"] == "Portal Admin") {
      criteriaSelector["userType"] = "Internal"
    }

    switch (status) {
      case 'loading':
        return (
          <AppView>
            <div className={classes.container}>
              <LoadingView classes={
                {}
              } />
            </div>
          </AppView>
        );
      default:
        return (
          <AppView>
            <div className={classes.container}>
                <QueryList
                history={this.props.history}
                  criteriaFormSelector={criteriaSelector}
                  onCriteriaFormSelection={this.onCriteriaFormSelection}
                  // criteriaForm={form}
                  resultsFormSelector={
                    {
                      "app":"admin",
                      "form":"groupSearchResults"
                    }
                  }
                  queryUrl="/api/group-search/query"
                  autoQuery={true}
                  addNewUrl="/groups/admin/new"
                  forceExecuteOnLoad={false}
                  supressSectionStatusIcon
                  actionsForItemRow={this.handleActionsForItemRow}
                  onRowClick={this.handleRowClick}
                  alwaysExecuteOnSubmit={true}
                  customRenderers={{}}
                  // excludeFromClear={["supplierID","vendorNbrs"]}
                  noResultsText="No Results Found"
              />
            </div>
          </AppView>
        );
    }
  }
}

export default withStyles(styles)(GroupAdminQueryList);



